"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeConstructionAccount = exports.createAndInitConstruction = exports.getAddInitInfosTx = exports.prepareConstruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("../constants");
const solana_utils_1 = require("../solana-utils");
const helpers_1 = require("./helpers");
const prepareConstruction = (program, construction, initActionIdx, initActionSplits, authority, amounts) => {
    const signers = authority.secretKey ? [authority] : [];
    const items = initActionSplits.map((split, i) => {
        return { idx: initActionIdx[i], split };
    });
    const createTxFn = (items) => {
        const idxs = items.map((i) => i.idx);
        const splits = items.map((i) => i.split);
        return (0, exports.getAddInitInfosTx)(program, idxs, splits, authority, construction, signers);
    };
    const addInitTxRequests = (0, helpers_1.breakUpInstrDataArrays)(items, createTxFn);
    return [
        ...addInitTxRequests,
        getPrepareTx(program, construction, signers, amounts, authority),
    ];
};
exports.prepareConstruction = prepareConstruction;
const getPrepareTx = (program, construction, signers, amounts, authority) => {
    return {
        tx: program.transaction.prepareConstruction(amounts, {
            accounts: {
                authority: authority.publicKey,
                construction: construction,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            },
            signers,
        }),
        signers,
    };
};
const getAddInitInfosTx = (program, initActionIdx, initActionSplits, authority, construction, signers) => {
    return {
        tx: program.transaction.addInitInfo(initActionIdx, initActionSplits.map((i) => new anchor_1.BN(i)), {
            accounts: {
                authority: authority.publicKey,
                construction: construction,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            },
            signers,
        }),
        signers,
    };
};
exports.getAddInitInfosTx = getAddInitInfosTx;
const createAndInitConstruction = (program, authority, numbActions) => __awaiter(void 0, void 0, void 0, function* () {
    const constructionSize = constants_1.CONSTRUCTION_ACCOUNT_SIZE;
    const ConstructionAccount = anchor_1.web3.Keypair.generate();
    const tx = program.transaction.initConstruction(numbActions, {
        accounts: {
            construction: ConstructionAccount.publicKey,
            authority,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        },
        signers: [ConstructionAccount],
        instructions: [
            yield web3_js_1.SystemProgram.createAccount({
                fromPubkey: program.provider.wallet.publicKey,
                newAccountPubkey: ConstructionAccount.publicKey,
                space: constructionSize + 8,
                lamports: (0, solana_utils_1.calculateRent)(constructionSize + 8, constants_1.LIFETIME_CONSTRUCTION_ACCOUNT_MS),
                programId: program.programId,
            }),
        ],
    });
    return {
        tx: { tx, signers: [ConstructionAccount] },
        construction: ConstructionAccount,
    };
});
exports.createAndInitConstruction = createAndInitConstruction;
const closeConstructionAccount = (program, construction, recipientSol, authority) => {
    const signers = authority.secretKey ? [authority] : [];
    const tx = program.transaction.closeConstruction({
        accounts: {
            construction: {
                construction,
                authority: authority.publicKey,
            },
            recipient: recipientSol,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        },
        signers,
    });
    return {
        tx,
        signers,
    };
};
exports.closeConstructionAccount = closeConstructionAccount;
